import styled from "styled-components";
import {
  MaterialCubicBezier,
  MobileWidth,
  PrimaryColor,
  Wrapper,
} from "../../GlobalStyle";

export const HeaderWrapper = styled.header`
  background-color: rgba(255, 255, 255, 0.9);
  //max-width: 100vw;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  transition: all 200ms ${MaterialCubicBezier};
  z-index: 10;

  &.top {
    background-color: rgba(255, 255, 255, 0.01);
    .logo-wrapper {
      img {
        height: 100px;
      }
    }
  }

  ${Wrapper} {
    display: flex;
    height: 70px;
    position: relative;
    @media screen and (max-width: ${MobileWidth}) {
      height: 50px;
      padding-left: 32px;
    }
  }

  .logo-wrapper {
    display: flex;
    align-items: center;
    position: absolute;
    top: 10px;
    left: -20px;
    clip-path: polygon(50% 0, 95% 25%, 95% 75%, 50% 100%, 5% 76%, 5% 25%);
    background-color: rgba(255, 255, 255, 0.9);
    padding: 10px;
    transform-origin: top left;
    @media screen and (max-width: ${MobileWidth}) {
      left: 32px;
    }

    img {
      height: 80px;
      transition: all 200ms ${MaterialCubicBezier};
      @media screen and (max-width: ${MobileWidth}) {
        height: 50px;
      }
    }
  }

  .nav {
    margin-left: auto;
    padding-top: 24px;

    @media screen and (max-width: ${MobileWidth}) {
      background-color: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(10px);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: calc(100vh - 50px);
      opacity: 0;
      padding: 0;
      pointer-events: none;
      position: fixed;
      left: 0;
      right: 0;
      top: 50px;
      transform: translateX(100%);
      transition: all 400ms ${MaterialCubicBezier};
      visibility: hidden;
      z-index: -1;

      &.active {
        opacity: 1;
        pointer-events: auto;
        transform: translateX(0);
        visibility: visible;
      }
    }

    .nav-item {
      color: #000;
      font-family: "Fjalla One", "Open Sans", sans-serif;
      font-size: 1.4rem;
      margin-left: 50px;
      text-transform: uppercase;
      @media screen and (max-width: ${MobileWidth}) {
        margin-bottom: 15px;
        margin-left: 0;
      }

      &:hover {
        color: ${PrimaryColor};
      }
    }
  }

  .hamburger {
    margin-left: auto;
    transform: scale(0.6);
    display: none;
    padding: 0;
    @media screen and (max-width: ${MobileWidth}) {
      display: block;
    }

    .hamburger-inner {
      background-color: ${PrimaryColor};
      transition-duration: 400ms;

      &:before,
      &:after {
        background-color: ${PrimaryColor};
        transition-duration: 400ms;
      }
    }
  }
`;
